import { ReactNode } from 'react';

import { setConfigOnce } from 'utils/config';

const WithConfig = ({
  config,
  children,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: Record<string, any>;
  children: ReactNode;
}) => {
  setConfigOnce(config);
  return children;
};

export default WithConfig;
